import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { organizationEndpoints } from '../../services/api/endpoints/organisation.endpoint';
import { Organisation } from '../../types/organization';
import { setSelectedOrganisation } from '../../store/slices/organizationSlice';
import { RootState } from '../../store';
import { logger } from '../../utils/logger';

export const useOrganisationActions = () => {
  const dispatch = useDispatch();
  const selectedOrganisation = useSelector(
    (state: RootState) => state.organizations.selectedOrganisation
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateOrganisation = async (id: string, data: Partial<Organisation>) => {
    setIsLoading(true);
    setError(null);

    try {
      await organizationEndpoints.updateOrganisation(id, data);
      // Backend returns only a success message, not the updated org.
      // Merge the partial update into the existing selected org.
      if (selectedOrganisation) {
        dispatch(setSelectedOrganisation({ ...selectedOrganisation, ...data }));
      }
      return { ...selectedOrganisation, ...data } as Organisation;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to update organization';
      setError(message);
      logger.error('Error updating organization:', err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateOrganisation,
    isLoading,
    error,
  };
};
